import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative items-center py-4" }
const _hoisted_2 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "relative items-center py-4" }
const _hoisted_5 = { class: "whitespace-nowrap text-sm font-medium not-italic text-gray-800" }
const _hoisted_6 = { class: "flex items-center justify-center" }
const _hoisted_7 = {
  class: "grid grid-cols-2 gap-6",
  style: {"grid-template-columns":"auto min-content"}
}
const _hoisted_8 = { class: "pb-3 pt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_map_location_selector = _resolveComponent("map-location-selector")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_small_loader = _resolveComponent("small-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_form_divider = _resolveComponent("form-divider")!
  const _component_button_wrapper = _resolveComponent("button-wrapper")!
  const _component_form_wrapper = _resolveComponent("form-wrapper")!
  const _component_modal_component = _resolveComponent("modal-component")!

  return (_openBlock(), _createBlock(_component_modal_component, {
    "is-displayed": _ctx.isCreateModalOpened,
    "no-padding": true,
    title: _ctx.$t('ParkingSpots.CreateTitle'),
    onToggleModal: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('toggle-modal')))
  }, {
    default: _withCtx(() => [
      (_ctx.isMapLocationModalOpened)
        ? (_openBlock(), _createBlock(_component_map_location_selector, {
            key: 0,
            "coordinates-prop": {
        lat: _ctx.parkingSpot.latitude,
        lng: _ctx.parkingSpot.longitude,
      },
            "is-map-location-modal-opened": _ctx.isMapLocationModalOpened,
            onToggleModal: _ctx.toggleMapLocationModal,
            onGetCoordinates: _ctx.getMarkerCoordinates
          }, null, 8, ["coordinates-prop", "is-map-location-modal-opened", "onToggleModal", "onGetCoordinates"]))
        : _createCommentVNode("", true),
      _createVNode(_component_form_wrapper, { "is-form-in-modal": true }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_form_divider, null, {
              default: _withCtx(() => [
                _createVNode(_component_input_field, {
                  modelValue: _ctx.parkingSpot.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parkingSpot.name) = $event)),
                  label: _ctx.$t('ParkingSpots.Name')
                }, null, 8, ["modelValue", "label"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("ParkingSpots.ParkingSpace")), 1),
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isParkingSpaceListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.parkingSpot.spaceId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.parkingSpot.spaceId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.parkingSpaces,
                          reduce: (space) => space.id,
                          label: "name"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("ParkingSpots.ParkingSpotType")), 1),
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.isParkingSpotTypesListLoading)
                      ? (_openBlock(), _createBlock(_component_small_loader, {
                          key: 0,
                          height: "h-8",
                          width: "w-8"
                        }))
                      : (_openBlock(), _createBlock(_component_v_select, {
                          key: 1,
                          modelValue: _ctx.parkingSpot.typeId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.parkingSpot.typeId) = $event)),
                          class: _normalizeClass(`mt-1 w-full`),
                          options: _ctx.parkingSpotTypes,
                          reduce: (space) => space.id,
                          label: "name"
                        }, null, 8, ["modelValue", "options", "reduce"]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_input_field, {
                      modelValue: _ctx.parkingSpot.latitude,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.parkingSpot.latitude) = $event)),
                      label: _ctx.$t('ParkingSpaces.Latitude'),
                      required: true
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_input_field, {
                      modelValue: _ctx.parkingSpot.longitude,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.parkingSpot.longitude) = $event)),
                      label: _ctx.$t('ParkingSpaces.Longitude'),
                      required: true
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_the_button, {
                      icon: ['fas', 'earth-europe'],
                      "button-type": "primaryButton",
                      type: "button",
                      onExecuteMethod: _ctx.toggleMapLocationModal
                    }, null, 8, ["onExecuteMethod"])
                  ])
                ]),
                _createVNode(_component_input_field, {
                  modelValue: _ctx.parkingSpot.index,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.parkingSpot.index) = $event)),
                  label: _ctx.$t('ParkingSpots.Index'),
                  type: "number"
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.parkingSpot.visible,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.parkingSpot.visible) = $event)),
                  "is-checked": _ctx.parkingSpot.visible,
                  label: _ctx.$t('ParkingSpots.Visible')
                }, null, 8, ["modelValue", "is-checked", "label"]),
                _createVNode(_component_checkbox_input, {
                  modelValue: _ctx.parkingSpot.public,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.parkingSpot.public) = $event)),
                  "is-checked": _ctx.parkingSpot.public,
                  label: _ctx.$t('ParkingSpots.Public')
                }, null, 8, ["modelValue", "is-checked", "label"])
              ]),
              _: 1
            }),
            _createVNode(_component_button_wrapper, { "is-submit-loading": _ctx.isSubmitLoading }, null, 8, ["is-submit-loading"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-displayed", "title"]))
}